import React from 'react';
import { Box, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { CustomerPersona, CustomerPersonas } from 'common/services/analytics/tractionAnalytics';
import { useTranslation } from 'services/localization';

export interface CustomerPersonaPickerProps {
	value: CustomerPersona | undefined;
	onChange: (value: CustomerPersona) => void;
}
const CustomerPersonaPicker = (props: CustomerPersonaPickerProps) => {
	const { value, onChange } = props;
	const { t } = useTranslation();

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		onChange(e.target.value as CustomerPersona);
	};

	return (
		<Box
			sx={{
				border: '1px solid rgba(0,0,0,0.23)',
				borderRadius: '4px',
				width: '100%',
				p: 2,
				position: 'relative',
			}}
		>
			<Typography
				variant="caption"
				color="secondary"
				sx={{
					position: 'absolute',
					top: '-10px',
					left: '8px',
					background: (theme) => theme.palette.background.default,
					px: '3px',
				}}
				id="customer-persona-label"
			>
				{t('register.tellUsAbitAboutYourself', 'Tell us a bit about yourself')}
			</Typography>
			<RadioGroup
				aria-labelledby="customer-persona-label"
				name="customer-persona"
				value={value ?? ''}
				onChange={handleChange}
			>
				<FormControlLabel
					value={CustomerPersonas.DISCOVERING}
					control={<Radio />}
					label={t('register.userPersonaDiscovering', 'I’m setting up my first online shop')}
				/>
				<FormControlLabel
					value={CustomerPersonas.REPLACING}
					control={<Radio />}
					label={t('register.userPersonaReplacing', 'I’m looking to replace my existing system')}
				/>
				<FormControlLabel
					value={CustomerPersonas.PLAYING}
					control={<Radio />}
					label={t('register.userPersonaPlaying', 'I’m just playing around')}
				/>
				<FormControlLabel
					value={CustomerPersonas.AGENCIES}
					control={<Radio />}
					label={t('register.userPersonaAgencies', 'I’m looking for a solution for my client')}
				/>
			</RadioGroup>
		</Box>
	);
};

export default CustomerPersonaPicker;
